<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>

        <v-container fluid>
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <th> Planner Code </th>
                        <th> Planner Name </th>
                        <th v-show="viewMode"> Created </th>
                        <th v-show="viewMode"> Updated </th>
                        <th v-show="viewMode"> Created By </th>
                        <th v-show="viewMode"> Updated By </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td>{{ user.planner_code }}</td>
                        <td>{{ user.planner_name }}</td>
                        <td v-show="viewMode">{{ user.created_at }}</td>
                        <td v-show="viewMode">{{ user.updated_at }}</td>
                        <td v-show="viewMode">{{ user.created_by }}</td>
                        <td v-show="viewMode">{{ user.updated_by }}</td>
                    </tr>
                    <tr v-if="users.length === 0">
                        <td :colspan="viewMode ? 6 : 2" class="text-center">No users found.</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-container>

        <!-- ADD DIALOG -->
        <v-dialog v-model="isOpen" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title>
                        <span class="overline"> Add User</span>
                    </v-card-title>
                    
                    <v-card-text>
                        <v-row class="mt-1">
                            <v-col class="mb-5" cols="12">
                                <v-checkbox
                                    v-model="forAll"
                                    label="Select All"
                                    dense
                                    hide-details
                                ></v-checkbox>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field 
                                    @input="getPlannerName"
                                    outlined 
                                    dense 
                                    label="Planner Code"
                                    v-model="form.user_id"
                                    class="required"
                                    :rules="getRequiredRules(forAll)"
                                    :disabled="forAll"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field 
                                    outlined 
                                    dense 
                                    label="Planner Name"
                                    v-model="plannersName"
                                    readonly
                                    :disabled="forAll"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="closeDialog()">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <app-buttons
            @toggleDialogStore="toggleDialogStore"
            :floatButtons="floatButtons">
        </app-buttons>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
import Swal from 'sweetalert2';

export default {
    components: {
        'app-toolbar': ToolbarMenu,
        'app-buttons': FloatingButtons,
    },

    data: () => ({
        forAll: false,
        isOpen: false,
        users: [],
        plannersName: '',
        form: {
            user_id: '',
        },
        toolbar: {
            title: "PH6 Planner Master",
            view: true,
            back: true,
            filter: false,
            master: false
        },

        floatButtons: {
            add: true,
        },
    }),

    computed : {
        ...mapState([
            'viewMode',
        ]),
    },

    created() {
        this.getPlanner();
    },

    methods: {
        getRequiredRules(isForAll) {
            return [
                v => isForAll || !!v || 'Planner Code is required.'
            ];
        },

        getPlannerName(userId) {
            axios.get('/api/get-planner-name', {
                params: { user_id: userId }
            })
            .then(res => {
                this.plannersName = res.data.name;
            })
            .catch(error => {
                console.error("Error fetching planner:", error);
                this.plannersName = '';
            });
        },

        toggleDialogStore(val) {
            this.isOpen = val;
            if (val) {
                this.form = { user_id: '' };
                this.forAll = false;
                if (this.$refs.Store) this.$refs.Store.resetValidation();
            }
        },

        getPlanner() {
            axios.get('/api/get-planner-master')
                .then(response => {
                    this.users = response.data.data;
                })
                .catch(error => {
                    console.error("Error fetching planners:", error);
                    this.users = []; 
                });
        },

        Store() {
            if (!this.$refs.Store.validate()) return;

            const payload = {
                user_id: this.form.user_id,
                is_all: this.forAll ? 1 : 0
            };

            const actionText = this.forAll 
                ? 'Are you sure you want to add all planners?' 
                : 'Are you sure you want to add this planner?';

            Swal.fire({
                title: actionText,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/add-planner-master', payload)
                    .then(response => {
                        this.isOpen = false;
                        this.getPlanner();
                        this.plannersName = '';
                        this.forAll = false;
                        this.form.user_id = '';

                        Swal.fire({
                            icon: 'success',
                            title: response.data.message || 'Data inserted successfully.',
                        }); 
                    })
                    .catch(error => {
                        console.error(error);
                        let errorMsg = 'Sorry, operation failed or planner already exists.';
                        if (error.response && error.response.status === 409) {
                            errorMsg = 'Sorry, planner already exists.';
                        }
                        Swal.fire({
                            icon: 'error',
                            title: errorMsg,
                        });                    
                    });
                } else {
                    this.plannersName = '';
                }
            });
        },
        
        closeDialog() {
            this.isOpen = false;
            this.plannersName = '';
            this.forAll = false;
        }
    },
}

</script>